import React, { Fragment, useState } from 'react';
import { Button, Card, CardBody, Col, Container, FormGroup, FormText, Input, Label, Row, Nav, NavLink, InputGroupAddon, InputGroupText, InputGroup } from 'reactstrap';
import { useAddAgreement } from '../../hooks/agreements/useAddAgreement';
import { SearchAsync } from '../../components/elements/SearchAsync';
import DeniReactTreeView from 'deni-react-treeview';
//import Select from 'react-select';
import Select, { components } from "react-select";

import { TableAgreement } from '../../components/agreement/TableAgreement';
import 'animate.css';
import { ModalCodeCsv } from './ModalCodeCsv';
import { ModalDeleteTest } from './ModalDeleteTest';
import { cedimi } from '../../constant/globalConstantsTypeClients'
import './StyleAgreement.css';
import { AlertDataTable } from '../../components/tableDataTable/AlertDataTable';
import { Dialog } from 'primereact/dialog';
import { AlertTriangle } from "react-feather";
import { FileUpload } from 'primereact/fileupload';
import { useRef } from "react";
import { Html5QrcodeErrorTypes } from 'html5-qrcode/esm/core';
import { almas } from '../../constant/globalConstantsTypeClients';




export const IndexAddAgreement = () => {

    const {
        //#region AGREEMENTS LIST
        listCompanies, listSellers, listCommercialLines,
        ListBranchesTree,
        //#endregion

        //#region AGREEMENTS MODELS
        informationCompany, informationDoctor, examProfileState, loading, globalPercentage, loadingAgreement, typeFilterAgreement,

        //FORM
        id_agreement, id_company, id_commercial_line, id_seller,
        contract_number, validity, sales_name, sales_phone, sales_email, payment_name, payment_phone,
        payment_email, observations, is_global,
        list_agrement_test,

        //FORM METHODS
        handleInputChangeA, handleSelectValuesA,
        //REFS
        treeViewRef,
        //#endregion

        //#region VALIDATIONS AGREEMENTS
        validationsAgreement, visibilityInputs,
        //#endregion  

        //#region AGREEMENTS METHODS
        handleChangeCompany, handleSelectTest, handleChangeRange, handleChangePercentage,
        handleDeleteRange, handleAddRange, handleDeleteTest, handleChangePrice, handleGoBack,
        saveOrUpdateAgreement, handleCalculateGlobalPercentage,

        //#endregion
        number_format,

        //#region csv Exam and Profile

        //#region sanitaria
        check_sanitary, on_check_sanitary, handleCant, is_micro,

        //RETURN PAGINATION
        goNextPage, goPreviousPage, totalPages, actualPage, goToPage,
        prevPage, nextPage, totalRecords, resultCount, handleSearch,

        modalListEgress, toggleModalListEgress, listCode, handlemove,
        listRepit, priceTarifarion, profileT,

        //* MODAL DELETE TEST
        modalCancellation, method, toggleModalCancellation, handleTest, modalTitle, informationExams, handleDeleteTestCreate,
        //*CSV
        ExamIndication, view_exams,
        _active_micro, results, loadingAgreementTest, isSearching, setGlobalPercentage,
        is_list_limited, on_check_list_limited,
        //* MOD AGREEMENTS
        agreement_mode, agreement_discount_global, id_rate,
        listAgreement, username_microsite, password_microsite,
        modalAlert, closeDeleteAlertCurrentlist, modalAlertCurrentlist, handleCleanCurrentlist,
        handleDeleteAndSave, closeDeleteAlert, loadingListCurrent,
        id_payment_configuration, listPaymet, automatic_lock, on_check_overdue,
        toggleAlert, showInvoiceAlert, changeAgreement, modalAlertAgreement, downloadTemplateCSV,

        //  * CONFIGURATION CLEAN AGREEMENT
        showMessageModal, isAction, isAction2, toggleAlert2, isAction3, toggleAlert3,
        resultsBackup, _url, border_tax,
        listSellerDeleted, agreementId

    } = useAddAgreement();


    let valid = agreementId === undefined ? listSellers : listSellerDeleted




    const hasChanges =
        JSON.stringify(list_agrement_test) !== JSON.stringify(resultsBackup);

    // console.log("¿Hay cambios?", hasChanges);



    const {
        id_company_valid,
        id_commercial_line_valid,
        id_seller_valid,
        contract_number_valid,
        validity_valid,
    } = validationsAgreement;


    let url_helen = localStorage.getItem('url_helen');
    const [typeUpload, setTypeUpload] = useState("2");
    const fileUploadRef = useRef(null);
    const [showPassword, setShowPassword] = useState(false);

    const toggleShowPassword = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    const emptyTemplate = () => (
        <div className="custom-empty">
            <div className="upload-icon text-center">
                <i className="pi pi-cloud-upload f-46"></i>
            </div>

            <div className="upload-text text-center">
                <strong>Haz clic para elegir  un archivo Excel/CSV</strong>
                <div>
                    O arrastra y suelta el archivo aquí.
                </div>
            </div>
        </div>
    );


    const {
        view_contact_number,
        view_validity,
        view_is_global,
        view_id_seller,
    } = visibilityInputs;


    // ? DELETE SELLER
    const CustomOption = (props) => {
        const { deleted } = props.data;

        return (
            <components.Option {...props}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        opacity: deleted ? 0.6 : 1
                    }}
                >
                    <span>
                        {deleted ? "🚫" : "✅"} {props.label}
                    </span>

                    <small
                        style={{
                            color: deleted ? "#ef4444" : "#22c55e",
                            fontWeight: 600
                        }}
                    >
                        {deleted ? "Vendedor eliminado" : "Vendedor vigente"}
                    </small>
                </div>
            </components.Option>
        );
    };

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused
                ? "#f8fafc"
                : "#fff",
            color: state.data.deleted
                ? "#9ca3af"
                : "#111827",
            cursor: state.data.deleted
                ? "not-allowed"
                : "pointer"
        })
    };

    const CustomSingleValue = (props) => {
        const { deleted } = props.data;

        return (
            <components.SingleValue {...props}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        lineHeight: "1.1"
                    }}
                >
                    <span
                        style={{
                            color: deleted ? "#ef4444" : "#111827",
                            fontWeight: 500
                        }}
                    >
                        {deleted ? "🚫" : "✅"} {props.data.label}
                    </span>

                    <small
                        style={{
                            color: deleted ? "#ef4444" : "#22c55e",
                            fontWeight: 600
                        }}
                    >
                        {deleted
                            ? "Vendedor eliminado"
                            : "Vendedor vigente"}
                    </small>
                </div>
            </components.SingleValue>
        );
    };

    return (
        <Fragment>
            <>
                <div className="customizer-links" style={{ width: "45px" }} >
                    <Nav className="flex-column nac-pills">
                        <NavLink onClick={handleGoBack} style={{ cursor: 'pointer' }} >
                            <div className="settings"  >
                                <i className="fa fa-reply f-18"></i>
                            </div>
                            <span>{"Regresar"}</span>
                        </NavLink>
                        <NavLink
                            onClick={!loading ? () => saveOrUpdateAgreement(false) : null}
                            style={{ cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}
                        >
                            <div className="settings">
                                {loading ? (
                                    <i className="fa fa-spinner fa-spin f-18"></i>
                                ) : (
                                    <i className="fa fa-floppy-o f-18"></i>
                                )}
                            </div>

                            <span>
                                {loading
                                    ? "Guardando..."
                                    : id_agreement > 0
                                        ? "Actualizar convenio"
                                        : "Guardar convenio"}
                            </span>
                        </NavLink>

                    </Nav>
                </div>
                <Container fluid={true} className='container-global-zoom' >
                    <Row>

                        <Col sm="12" md="12" lg="12" hidden={!loadingAgreement}>
                            <Col sm="12" style={{ textAlign: "center" }} >
                                <img src={require("../../assets/images/loginHelenLabs/HelenLabs.png")} className='animate__animated animate__pulse animate__infinite ' style={{ width: '150px' }} />
                                <br /> <p className='f-w-600 f-14 badge badge-light-primary' >Cargando información...</p>
                            </Col>
                        </Col>

                        <Col sm="12" md="12" lg="12" hidden={loadingAgreement}>
                            {
                                // ? CONFIGURATION AGREEMENT
                            }
                            <div className="information-agreement" >
                                <Card className="border-0 shadow-sm mb-0">
                                    <Row>
                                        <Col sm="12" md="6" lg="6">
                                            <div
                                                className={
                                                    informationCompany?.is_pay_for_compamy_value === "Crédito(A la empresa)" ||
                                                        informationCompany?.is_pay_for_compamy_value === "Ambas(Mixto)"
                                                        ? "information-agreement "
                                                        : "information-agreement"
                                                }
                                            >
                                                <div className="header">
                                                    <h6 className="m-0 f-w-600">
                                                        Datos del convenio
                                                    </h6>

                                                    <span className="required-badge">
                                                        Convenio para empresas
                                                    </span>
                                                </div>
                                                <CardBody className="body">
                                                    <Row
                                                        className={
                                                            informationCompany?.is_pay_for_compamy_value === "Crédito(A la empresa)" ||
                                                                informationCompany?.is_pay_for_compamy_value === "Ambas(Mixto)"
                                                                ? "mb-2"
                                                                : "mb-2"
                                                        }
                                                    >
                                                        <Col sm="12" md="6"
                                                            hidden={id_agreement > 0}
                                                        >
                                                            {typeFilterAgreement === 1 &&
                                                                <FormGroup>
                                                                    <Label className='f-w-600'>
                                                                        Filtrar por cliente
                                                                    </Label>

                                                                    <Select
                                                                        name="id_company"
                                                                        isClearable
                                                                        placeholder="Selecciona una opción"
                                                                        options={listCompanies}
                                                                        defaultValue={id_company}
                                                                        value={id_company}
                                                                        className='input-air-primary'
                                                                        onChange={(e) => handleChangeCompany(e)}
                                                                        isDisabled={id_agreement > 0}
                                                                    />

                                                                    <FormText
                                                                        color='danger'
                                                                        hidden={!id_company_valid}
                                                                    >
                                                                        Selecciona un cliente
                                                                    </FormText>
                                                                </FormGroup>
                                                            }
                                                        </Col>

                                                        <Col sm="12" md="6"
                                                            hidden={id_agreement > 0}
                                                        >
                                                            <FormGroup>
                                                                <Label className='f-w-600'>
                                                                    Selecciona una razón social
                                                                </Label>

                                                                <Select
                                                                    name="id_commercial_line"
                                                                    defaultValue={id_commercial_line}
                                                                    value={id_commercial_line}
                                                                    isClearable={false}
                                                                    placeholder="Selecciona una opción"
                                                                    options={listCommercialLines}
                                                                    onChange={(e) =>
                                                                        handleSelectValuesA(
                                                                            e,
                                                                            'id_commercial_line'
                                                                        )
                                                                    }
                                                                    isDisabled={id_agreement > 0}
                                                                    menuPortalTarget={document.body}
                                                                />

                                                                <FormText
                                                                    color='danger'
                                                                    hidden={!id_commercial_line_valid}
                                                                >
                                                                    Selecciona una razón social
                                                                </FormText>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>


                                                    <div className="client-card mb-4 ">
                                                        <div className="d-flex align-items-center mb-4 ">
                                                            <img alt="flask" className="img-fluid text-info mr-2" src={require("../../assets/images/price/reportCxcCompany.svg")} style={{ width: "65px", height: "65px" }} />
                                                            <div>
                                                                <div className="client-name">
                                                                    {informationCompany?.name ?? "N/A"}
                                                                </div>
                                                                {
                                                                    typeFilterAgreement === 1 &&
                                                                    informationCompany?.company_turn &&
                                                                    <div className="client-turn">
                                                                        {informationCompany.company_turn}
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                        <Row>
                                                            <Col sm="3">
                                                                <div className="info-title">
                                                                    Teléfono
                                                                </div>
                                                                <div className="info-value">
                                                                    {informationCompany?.phone ?? "N/A"}
                                                                </div>
                                                            </Col>
                                                            <Col sm="3">
                                                                <div className="info-title">
                                                                    RFC
                                                                </div>
                                                                <div className="info-value">
                                                                    {informationCompany?.rfc ?? "N/A"}
                                                                </div>
                                                            </Col>
                                                            {
                                                                (informationCompany?.is_pay_for_compamy_value === "Crédito(A la empresa)" ||
                                                                    informationCompany?.is_pay_for_compamy_value === "Ambas(Mixto)") && <Col sm="2" className="pl-0 pr-0">
                                                                    <div className="info-title">
                                                                        Plazo de crédito
                                                                    </div>
                                                                    <div className="info-value">
                                                                        {informationCompany?.payment_periodicity_value ?? "N/A"} dias
                                                                    </div>

                                                                </Col>
                                                            }

                                                            <Col sm="4">
                                                                <div className="info-title">
                                                                    Esquema de cobro
                                                                </div>
                                                                <div className="info-value">
                                                                    {informationCompany?.is_pay_for_compamy_value ?? "N/A"}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>

                                                    <h6 className="section-title">
                                                        Detalles del contrato
                                                    </h6>
                                                    <Row
                                                        className={
                                                            informationCompany?.is_pay_for_compamy_value === "Crédito(A la empresa)" ||
                                                                informationCompany?.is_pay_for_compamy_value === "Ambas(Mixto)"
                                                                ? "pb-2"
                                                                : ""
                                                        }
                                                    >
                                                        <Col md="4">
                                                            <FormGroup>
                                                                <Label>
                                                                    No de Contrato / Nombre *
                                                                </Label>
                                                                <Input
                                                                    type='text'
                                                                    name="contract_number"
                                                                    value={contract_number}
                                                                    onChange={handleInputChangeA}
                                                                    invalid={contract_number_valid}
                                                                    readOnly={!view_contact_number}

                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="4">
                                                            <FormGroup>
                                                                <Label>
                                                                    Fecha expiración *
                                                                </Label>
                                                                <Input
                                                                    type='date'
                                                                    name="validity"
                                                                    value={validity}
                                                                    onChange={handleInputChangeA}
                                                                    invalid={validity_valid}
                                                                    readOnly={!view_validity}
                                                                />
                                                            </FormGroup>
                                                        </Col>

                                                        <Col md="4">
                                                            <div className="switch-container">
                                                                <Label>
                                                                    ¿Fijar convenio principal?
                                                                </Label>
                                                                <Input
                                                                    type='select'
                                                                    className=' form-control-sm'
                                                                    name="is_global"
                                                                    value={is_global}
                                                                    onChange={handleInputChangeA}
                                                                    disabled={informationCompany.agreement_global}
                                                                    readOnly={!view_is_global}
                                                                >
                                                                    <option value={true}>
                                                                        Si
                                                                    </option>

                                                                    <option value={false}>
                                                                        No
                                                                    </option>

                                                                </Input>
                                                            </div>
                                                        </Col>
                                                        <Col sm="12" >
                                                            <Row>
                                                                <Col sm={_active_micro === "True" ? (almas === _url ? "4" : "6") : "12"} >
                                                                    <FormGroup>
                                                                        <Label>
                                                                            Observaciones
                                                                        </Label>
                                                                        <Input
                                                                            type="textarea"
                                                                            name="observations"
                                                                            value={observations}
                                                                            onChange={handleInputChangeA}
                                                                            placeholder="Agrega notas..."
                                                                        />
                                                                    </FormGroup>

                                                                </Col>
                                                                <Col sm={almas === _url ? "4" : "6"} >
                                                                    {
                                                                        _active_micro === "True" &&
                                                                        <div className="micro-card">
                                                                            <div>
                                                                                <div className="f-w-600">
                                                                                    Convenio para micro sanitaria
                                                                                </div>
                                                                                <small className="text-muted">
                                                                                    Configuración específica
                                                                                </small>
                                                                            </div>

                                                                            <Label className="switch m-0">
                                                                                <Input
                                                                                    type="checkbox"
                                                                                    checked={is_micro}
                                                                                    onChange={on_check_sanitary}
                                                                                />
                                                                                <span className="slider round"></span>
                                                                            </Label>
                                                                        </div>
                                                                    }

                                                                </Col>

                                                                {
                                                                    // ? TAX
                                                                }
                                                                {
                                                                    almas === _url && <Col sm="4" >

                                                                        <div className="micro-card">
                                                                            <div>
                                                                                <div className="f-w-600">
                                                                                    Configuración de iva
                                                                                </div>
                                                                                <small className="text-muted">
                                                                                    Iva al {border_tax ? '8%' : '16%'}  para este convenio
                                                                                </small>
                                                                            </div>

                                                                            <Label className="switch m-0">
                                                                                <Input

                                                                                    type="checkbox" name="border_tax" onChange={handleInputChangeA} checked={border_tax}
                                                                                />
                                                                                <span className="slider round"></span>
                                                                            </Label>
                                                                        </div>  </Col>
                                                                }


                                                            </Row>




                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </div>
                                        </Col>
                                        <Col
                                            sm="6"
                                            className={
                                                (informationCompany.rfc === undefined &&
                                                    informationDoctor.specialty === undefined)
                                                    ? "d-none"
                                                    : "p-l-0 p-r-0"
                                            }
                                        >
                                            <Card className="information-agreement border-0 shadow-sm">
                                                <CardBody className="body">
                                                    <h6 className={
                                                        informationCompany?.is_pay_for_compamy_value === "Crédito(A la empresa)" ||
                                                            informationCompany?.is_pay_for_compamy_value === "Ambas(Mixto)"
                                                            ? "section-title"
                                                            : "d-none"
                                                    } >
                                                        Seguimiento de cobranza
                                                    </h6>
                                                    <Row
                                                        className={
                                                            informationCompany?.is_pay_for_compamy_value === "Crédito(A la empresa)" ||
                                                                informationCompany?.is_pay_for_compamy_value === "Ambas(Mixto)"
                                                                ? ""
                                                                : "d-none"
                                                        }
                                                    >
                                                        <Col sm="12">

                                                            <div className="agreement-payment-container">

                                                                <Label className="agreement-title mb-0">
                                                                    Seguimiento por:
                                                                    <span className="required">*</span>
                                                                </Label>

                                                                <div className="agreement-options">

                                                                    {
                                                                        listPaymet?.map((_financing) => (
                                                                            <FormGroup
                                                                                check
                                                                                key={`financing-${_financing.id_payment_configuration}`}
                                                                                className={`agreement-radio ${Number(id_payment_configuration) ===
                                                                                    _financing.id_payment_configuration
                                                                                    ? "agreement-activepayment"
                                                                                    : ""
                                                                                    }`}
                                                                            >
                                                                                <Label
                                                                                    check
                                                                                    className="d-flex align-items-center w-100 mb-0"
                                                                                    style={{ cursor: "pointer" }}
                                                                                >
                                                                                    <Input
                                                                                        type="radio"
                                                                                        name="id_payment_configuration"
                                                                                        value={_financing.id_payment_configuration}
                                                                                        checked={
                                                                                            Number(id_payment_configuration) ===
                                                                                            _financing.id_payment_configuration
                                                                                        }
                                                                                        onChange={handleInputChangeA}
                                                                                    />

                                                                                    <span className="agreement-label">
                                                                                        {_financing.method}
                                                                                    </span>
                                                                                </Label>
                                                                            </FormGroup>
                                                                        ))
                                                                    }

                                                                </div>

                                                                {(id_payment_configuration === 1 ||
                                                                    id_payment_configuration === "1") && (

                                                                        <div className="agreement-lock-container">

                                                                            <span className="agreement-lock-label">
                                                                                Bloque automático
                                                                            </span>

                                                                            <Label className="switch m-0">
                                                                                <Input
                                                                                    type="checkbox"
                                                                                    checked={automatic_lock === 1}
                                                                                    onChange={on_check_overdue}
                                                                                />
                                                                                <span className="slider round"></span>
                                                                            </Label>

                                                                        </div>

                                                                    )}

                                                            </div>

                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-3">
                                                        <Col sm="12" md="6">
                                                            <h6 className="section-title">
                                                                Asignación Comercial
                                                            </h6>
                                                        </Col>

                                                        <Col sm="12" md="6">
                                                            <h6 className="section-title">
                                                                Administración de sucursales
                                                            </h6>
                                                        </Col>
                                                    </Row>



                                                    <Row>
                                                        <Col sm="12" md="6">
                                                            <FormGroup>
                                                                <Label>
                                                                    Vendedor asignado *
                                                                </Label>
                                                                {
                                                                    agreementId === undefined ?
                                                                        <Select
                                                                            name="id_seller"
                                                                            defaultValue={id_seller}
                                                                            value={id_seller}
                                                                            isClearable
                                                                            placeholder="Selecciona una opción"
                                                                            options={valid}
                                                                            className='input-air-primary'
                                                                            onChange={(e) =>
                                                                                handleSelectValuesA(
                                                                                    e,
                                                                                    "id_seller"
                                                                                )
                                                                            }
                                                                            isDisabled={!view_id_seller}
                                                                        />
                                                                        :
                                                                        <Select
                                                                            name="id_seller"
                                                                            value={id_seller}
                                                                            isClearable
                                                                            placeholder="Selecciona un vendedor"
                                                                            options={valid}
                                                                            components={{
                                                                                Option: CustomOption,
                                                                                SingleValue: CustomSingleValue
                                                                            }}
                                                                            styles={customStyles}
                                                                            isOptionDisabled={(option) => option.deleted}
                                                                            onChange={(e) =>
                                                                                handleSelectValuesA(e, "id_seller")
                                                                            }
                                                                            isDisabled={!view_id_seller}
                                                                        />
                                                                    // <Select
                                                                    //     name="id_seller"
                                                                    //     value={id_seller}
                                                                    //     isClearable
                                                                    //     placeholder="Selecciona un vendedor"
                                                                    //     options={valid}
                                                                    //     components={{
                                                                    //         Option: CustomOption
                                                                    //     }}
                                                                    //     styles={customStyles}
                                                                    //     isOptionDisabled={(option) => option.deleted}
                                                                    //     onChange={(e) =>
                                                                    //         handleSelectValuesA(e, "id_seller")
                                                                    //     }
                                                                    //     isDisabled={!view_id_seller}
                                                                    // />

                                                                }

                                                                {/* <Select
                                                                    name="id_seller"
                                                                    defaultValue={id_seller}
                                                                    value={id_seller}
                                                                    isClearable
                                                                    placeholder="Selecciona una opción"
                                                                    options={valid}
                                                                    className='input-air-primary'
                                                                    onChange={(e) =>
                                                                        handleSelectValuesA(
                                                                            e,
                                                                            "id_seller"
                                                                        )
                                                                    }
                                                                    isDisabled={!view_id_seller}
                                                                /> */}
                                                                <FormText
                                                                    color='danger'
                                                                    hidden={!id_seller_valid}
                                                                >
                                                                    Selecciona un vendedor
                                                                </FormText>
                                                            </FormGroup>

                                                            <Row className="pt-4 pl-3">
                                                                <h6 className="section-title">
                                                                    Configuración del micrositio

                                                                </h6>

                                                            </Row>
                                                            <FormGroup>
                                                                <Label>Usuario</Label>
                                                                <Input
                                                                    type="text"
                                                                    className="custom-input"
                                                                    name="username_microsite"
                                                                    value={username_microsite}
                                                                    onChange={handleInputChangeA}
                                                                    placeholder="Nombre de usuario"
                                                                    autoComplete="new-password"


                                                                />
                                                            </FormGroup>

                                                            <FormGroup>
                                                                <Label>Contraseña</Label>
                                                                <InputGroup>
                                                                    <Input
                                                                        type={
                                                                            showPassword
                                                                                ? "text"
                                                                                : "password"
                                                                        }
                                                                        className="custom-input"
                                                                        name="password_microsite"
                                                                        value={password_microsite}
                                                                        onChange={handleInputChangeA}
                                                                        placeholder="Contraseña"
                                                                        autoComplete="new-password"


                                                                    />
                                                                    <InputGroupAddon addonType="append">
                                                                        <InputGroupText>
                                                                            <span
                                                                                className={`fa fa-eye${showPassword ? "-slash" : ""}`}
                                                                                onClick={toggleShowPassword}
                                                                                style={{ cursor: "pointer" }}
                                                                            />
                                                                        </InputGroupText>
                                                                    </InputGroupAddon>
                                                                </InputGroup>
                                                            </FormGroup>





                                                        </Col>



                                                        <Col sm="12" md="6" className='pl-0' >
                                                            <div
                                                                className="agreement-tree-scroll"
                                                                style={{ width: "100%" }}
                                                            >
                                                                <DeniReactTreeView
                                                                    items={ListBranchesTree}
                                                                    ref={treeViewRef}
                                                                    showCheckbox={true}
                                                                    showIcon={true}
                                                                    style={

                                                                        informationCompany?.is_pay_for_compamy_value === "Crédito(A la empresa)" ||
                                                                            informationCompany?.is_pay_for_compamy_value === "Ambas(Mixto)"
                                                                            ? {
                                                                                height: "310px",
                                                                                width: "100%"
                                                                            }
                                                                            : {
                                                                                height: "400px",
                                                                                width: "100%"
                                                                            }


                                                                    }
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>


                                                </CardBody>
                                            </Card>
                                        </Col>
                                        {
                                            // ? SELLER
                                        }
                                        <Col sm="12" className={
                                            (informationCompany.rfc === undefined &&
                                                informationDoctor.specialty === undefined)
                                                ? "d-none"
                                                : "p-l-0 p-r-0"
                                        }  >
                                            <CardBody className="pt-0" >
                                                <Row>

                                                    {/* Empresa */}
                                                    <Col sm="12" md="6">

                                                        <div className="agreement-contactpanel">

                                                            <div className="agreement-contactheader">
                                                                <i className="fa fa-building mr-2"></i>
                                                                Datos de contacto (Empresa)
                                                            </div>

                                                            <Row className="mt-3">

                                                                <Col md="4">
                                                                    <FormGroup>
                                                                        <Label>Nombre</Label>
                                                                        <Input
                                                                            type="text"
                                                                            className="form-control-sm input-air-primary b-r-9"
                                                                            name='sales_name'
                                                                            value={sales_name}
                                                                            onChange={handleInputChangeA}
                                                                        />
                                                                    </FormGroup>
                                                                </Col>

                                                                <Col md="4">
                                                                    <FormGroup>
                                                                        <Label>Teléfono</Label>
                                                                        <Input
                                                                            type="text"
                                                                            className="form-control-sm input-air-primary b-r-9"
                                                                            name='sales_phone'
                                                                            value={sales_phone}
                                                                            onChange={handleInputChangeA}
                                                                        />
                                                                    </FormGroup>
                                                                </Col>

                                                                <Col md="4">
                                                                    <FormGroup>
                                                                        <Label>Correo</Label>
                                                                        <Input
                                                                            type="email"
                                                                            className="form-control-sm input-air-primary b-r-9"
                                                                            name='sales_email'
                                                                            value={sales_email}
                                                                            onChange={handleInputChangeA}
                                                                        />
                                                                    </FormGroup>
                                                                </Col>

                                                            </Row>

                                                        </div>

                                                    </Col>


                                                    {/* Pagos */}
                                                    <Col sm="12" md="6">

                                                        <div className="agreement-contactpanel">

                                                            <div className="agreement-contactheader agreement-paymentheader">

                                                                <i className="fa fa-credit-card mr-2"></i>
                                                                Datos de contacto de pagos

                                                            </div>

                                                            <Row className="mt-3">

                                                                <Col md="4">
                                                                    <FormGroup>
                                                                        <Label>Nombre</Label>
                                                                        <Input
                                                                            type="text"
                                                                            className="form-control-sm input-air-primary b-r-9"
                                                                            name='payment_name'
                                                                            value={payment_name}
                                                                            onChange={handleInputChangeA}
                                                                        />
                                                                    </FormGroup>
                                                                </Col>

                                                                <Col md="4">
                                                                    <FormGroup>
                                                                        <Label>Teléfono</Label>
                                                                        <Input
                                                                            type="text"
                                                                            className="form-control-sm input-air-primary b-r-9"
                                                                            name='payment_phone'
                                                                            value={payment_phone}
                                                                            onChange={handleInputChangeA}
                                                                        />
                                                                    </FormGroup>
                                                                </Col>

                                                                <Col md="4">
                                                                    <FormGroup>
                                                                        <Label>Correo</Label>
                                                                        <Input
                                                                            type="email"
                                                                            className="form-control-sm input-air-primary b-r-9"
                                                                            name='payment_email'
                                                                            value={payment_email}
                                                                            onChange={handleInputChangeA}
                                                                        />
                                                                    </FormGroup>
                                                                </Col>

                                                            </Row>

                                                        </div>

                                                    </Col>

                                                </Row>

                                            </CardBody>
                                        </Col>
                                    </Row>
                                </Card>
                            </div>
                            {
                                // ? END CONFIGURATION AGREEMENT
                            }


                            {
                                // ? CONFIGURATION 
                            }

                            <Col sm="12" className="pl-0 pr0 pt-3 pb-5"  >

                                <Card className={
                                    (id_agreement === null)
                                        ? "d-none"
                                        : "shadow-sm border-0 b-r-15 overflow-hidden"
                                }  >

                                    <div
                                        className='px-4 py-3 d-flex justify-content-between align-items-center'
                                        style={{
                                            background: "#274b7a",
                                            color: "white"
                                        }}
                                    >
                                        <div>
                                            <h5 className='mb-1 f-w-600 text-white'>
                                                Configuración del Convenio
                                            </h5>

                                            <span className='f-12 opacity-75'>
                                                Administración de sucursales, descuentos y tarifarios
                                            </span>
                                        </div>

                                        <i className='fa fa-cogs f-20'></i>
                                    </div>

                                    <CardBody className='p-4'>
                                        <Row>
                                            {
                                                id_agreement > 0 && <Col lg="12" className="pl-3">

                                                    <div className='agreement-section-card'>

                                                        <h6 className="section-title" style={{ fontSize: "17px", fontWeight: "700" }} >
                                                            Modo de convenio
                                                        </h6>

                                                        <Row>
                                                            <Col md="12" className='mb-3 pl-0'>
                                                                <Col sm="12">


                                                                    <Row className='g-3'>

                                                                        {/* PRECIO ESPECIAL */}
                                                                        <Col md="4">

                                                                            <div
                                                                                onClick={() => {

                                                                                    const canChange = changeAgreement(1);

                                                                                    if (!canChange) return;

                                                                                    handleInputChangeA({
                                                                                        target: {
                                                                                            name: "agreement_mode",
                                                                                            value: 1
                                                                                        }
                                                                                    });

                                                                                }}
                                                                                style={{
                                                                                    border:
                                                                                        agreement_mode === 1 || agreement_mode === "1"
                                                                                            ? "2px solid #0f3d5e"
                                                                                            : "1px solid #dfe7ef",

                                                                                    background:
                                                                                        agreement_mode === 1 || agreement_mode === "1"
                                                                                            ? "#eef6fb"
                                                                                            : "#fff",

                                                                                    borderRadius: "14px",
                                                                                    padding: "16px",
                                                                                    cursor: "pointer",
                                                                                    transition: ".2s",
                                                                                    height: "100%"
                                                                                }}
                                                                            >

                                                                                <div
                                                                                    style={{
                                                                                        width: "40px",
                                                                                        height: "40px",
                                                                                        borderRadius: "12px",
                                                                                        background: "#f5761d36",
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "center",
                                                                                        marginBottom: "10px"
                                                                                    }}
                                                                                >
                                                                                    <i
                                                                                        className="pi pi-tag"
                                                                                        style={{
                                                                                            color: "#ef7900",
                                                                                            fontSize: "1rem"
                                                                                        }}
                                                                                    />
                                                                                </div>

                                                                                <div
                                                                                    style={{
                                                                                        fontWeight: 600,
                                                                                        color: "#0f3d5e",
                                                                                        fontSize: "14px"
                                                                                    }}
                                                                                >
                                                                                    Precio Especial
                                                                                </div>

                                                                                <div
                                                                                    style={{
                                                                                        fontSize: "11px",
                                                                                        color: "#6c757d",
                                                                                        marginTop: "4px"
                                                                                    }}
                                                                                >
                                                                                    Configura precios por estudio de forma manual o mediante carga masiva.
                                                                                </div>

                                                                            </div>

                                                                        </Col>

                                                                        {/* TARIFARIO MADRE */}
                                                                        <Col md="4">

                                                                            <div
                                                                                onClick={() => {

                                                                                    const canChange = changeAgreement(2);

                                                                                    if (!canChange) return;

                                                                                    handleInputChangeA({
                                                                                        target: {
                                                                                            name: "agreement_mode",
                                                                                            value: 2
                                                                                        }
                                                                                    });

                                                                                }}

                                                                                style={{
                                                                                    border:
                                                                                        agreement_mode === 2 || agreement_mode === "2"
                                                                                            ? "2px solid #0f3d5e"
                                                                                            : "1px solid #dfe7ef",

                                                                                    background:
                                                                                        agreement_mode === 2 || agreement_mode === "2"
                                                                                            ? "#eef6fb"
                                                                                            : "#fff",

                                                                                    borderRadius: "14px",
                                                                                    padding: "16px",
                                                                                    cursor: "pointer",
                                                                                    transition: ".2s",
                                                                                    height: "100%"
                                                                                }}
                                                                            >

                                                                                <div
                                                                                    style={{
                                                                                        width: "40px",
                                                                                        height: "40px",
                                                                                        borderRadius: "12px",
                                                                                        background: "#f5761d36",
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "center",
                                                                                        marginBottom: "10px"
                                                                                    }}
                                                                                >
                                                                                    <i
                                                                                        className="pi pi-book"
                                                                                        style={{
                                                                                            color: "#ef7900",
                                                                                            fontSize: "1rem"
                                                                                        }}
                                                                                    />
                                                                                </div>

                                                                                <div
                                                                                    style={{
                                                                                        fontWeight: 600,
                                                                                        color: "#0f3d5e",
                                                                                        fontSize: "14px"
                                                                                    }}
                                                                                >
                                                                                    Tarifario Madre
                                                                                </div>

                                                                                <div
                                                                                    style={{
                                                                                        fontSize: "11px",
                                                                                        color: "#6c757d",
                                                                                        marginTop: "4px"
                                                                                    }}
                                                                                >
                                                                                    Se tomará el tarifario del público general y se podrá aplicar un descuento global, de manera opcional.
                                                                                </div>

                                                                            </div>

                                                                        </Col>

                                                                        {/* TARIFARIO REFERENCIA */}
                                                                        {
                                                                            url_helen === cedimi && (
                                                                                <Col md="4">

                                                                                    <div
                                                                                        onClick={() => {

                                                                                            const canChange = changeAgreement(3);

                                                                                            if (!canChange) return;

                                                                                            handleInputChangeA({
                                                                                                target: {
                                                                                                    name: "agreement_mode",
                                                                                                    value: 3
                                                                                                }
                                                                                            });

                                                                                        }}


                                                                                        style={{
                                                                                            border:
                                                                                                agreement_mode === 3 || agreement_mode === "3"
                                                                                                    ? "2px solid #0f3d5e"
                                                                                                    : "1px solid #dfe7ef",

                                                                                            background:
                                                                                                agreement_mode === 3 || agreement_mode === "3"
                                                                                                    ? "#eef6fb"
                                                                                                    : "#fff",

                                                                                            borderRadius: "14px",
                                                                                            padding: "16px",
                                                                                            cursor: "pointer",
                                                                                            transition: ".2s",
                                                                                            height: "100%"
                                                                                        }}
                                                                                    >

                                                                                        <div
                                                                                            style={{
                                                                                                width: "40px",
                                                                                                height: "40px",
                                                                                                borderRadius: "12px",
                                                                                                background: "#f5761d36",
                                                                                                display: "flex",
                                                                                                alignItems: "center",
                                                                                                justifyContent: "center",
                                                                                                marginBottom: "10px"
                                                                                            }}
                                                                                        >
                                                                                            <i
                                                                                                className="pi pi-clone"
                                                                                                style={{
                                                                                                    color: "#ef7900",
                                                                                                    fontSize: "1rem"
                                                                                                }}
                                                                                            />
                                                                                        </div>

                                                                                        <div
                                                                                            style={{
                                                                                                fontWeight: 600,
                                                                                                color: "#0f3d5e",
                                                                                                fontSize: "14px"
                                                                                            }}
                                                                                        >
                                                                                            Tarifario Referencia
                                                                                        </div>

                                                                                        <div
                                                                                            style={{
                                                                                                fontSize: "11px",
                                                                                                color: "#6c757d",
                                                                                                marginTop: "4px"
                                                                                            }}
                                                                                        >
                                                                                            Utiliza los precios estándar del tarifario de referencia definidos, sin modificaciones.
                                                                                        </div>

                                                                                    </div>

                                                                                </Col>
                                                                            )
                                                                        }
                                                                    </Row>
                                                                    {
                                                                        agreement_mode !== "2" &&
                                                                        agreement_mode !== 2 &&
                                                                        agreement_mode !== 3 &&
                                                                        agreement_mode !== "3" && (

                                                                            // <div
                                                                            //     className='mt-4'
                                                                            //     style={{
                                                                            //         border: "1px solid #dfe7ef",
                                                                            //         borderRadius: "14px",
                                                                            //         padding: "16px 18px",
                                                                            //         background: "#fff",
                                                                            //         boxShadow: "0 2px 6px rgba(0,0,0,.05)",
                                                                            //         display: "flex",
                                                                            //         alignItems: "center",
                                                                            //         justifyContent: "space-between",
                                                                            //         gap: "15px"
                                                                            //     }}
                                                                            // >
                                                                            <div
                                                                                className='mt-4'
                                                                                style={{
                                                                                    border: is_list_limited ? "1px solid #4aa3ff" : "1px solid #dfe7ef",
                                                                                    borderRadius: "14px",
                                                                                    padding: "16px 18px",
                                                                                    background: is_list_limited ? "#eaf6ff" : "#fff",
                                                                                    boxShadow: is_list_limited
                                                                                        ? "0 2px 10px #85b1f7"
                                                                                        : "0 2px 6px rgba(0,0,0,.05)",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "space-between",
                                                                                    gap: "15px",
                                                                                    transition: "all 0.2s ease-in-out"
                                                                                }}
                                                                            >

                                                                                <div
                                                                                    style={{
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        gap: "14px"
                                                                                    }}
                                                                                >

                                                                                    <div
                                                                                        style={{
                                                                                            width: "42px",
                                                                                            height: "42px",
                                                                                            borderRadius: "12px",
                                                                                            background: is_list_limited ? "#cfe9ff" : "#d8ebf7",
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                            justifyContent: "center",
                                                                                            border: is_list_limited ? "1px solid #4aa3ff" : "none",
                                                                                            transition: "all 0.2s ease-in-out"
                                                                                        }}
                                                                                    >
                                                                                        <i
                                                                                            className="pi pi-list"
                                                                                            style={{
                                                                                                color: is_list_limited ? "#1e88e5" : "#0f3d5e",
                                                                                                fontSize: "1rem",
                                                                                                transition: "all 0.2s ease-in-out"
                                                                                            }}
                                                                                        />
                                                                                    </div>

                                                                                    <div>

                                                                                        <div
                                                                                            style={{
                                                                                                fontWeight: 600,
                                                                                                color: "#0f3d5e",
                                                                                                fontSize: "14px"
                                                                                            }}
                                                                                        >
                                                                                            Incluir estudios de tarifario base
                                                                                        </div>

                                                                                        <div
                                                                                            style={{
                                                                                                fontSize: "11px",
                                                                                                color: "#6c757d",
                                                                                                marginTop: "3px"
                                                                                            }}
                                                                                        >
                                                                                            Además de los precios especiales, el cliente podrá solicitar cualquier otro estudio a precio de lista.
                                                                                        </div>

                                                                                    </div>

                                                                                </div>

                                                                                <Label className="switch m-0">

                                                                                    <Input
                                                                                        type="checkbox"
                                                                                        name="isCommercialPartner"
                                                                                        onChange={on_check_list_limited}
                                                                                        checked={is_list_limited}
                                                                                    />

                                                                                    <span className="slider round"></span>

                                                                                </Label>

                                                                            </div>
                                                                        )
                                                                    }

                                                                    {
                                                                        // * NEW MODE
                                                                    }
                                                                    {
                                                                        agreement_mode !== 2 && agreement_mode !== "2" && agreement_mode !== 3 && agreement_mode !== "3" &&
                                                                        <Row className='mt-4'>

                                                                            <Col sm="12">

                                                                                <div
                                                                                    style={{
                                                                                        background: "#fff",
                                                                                        borderRadius: "16px",
                                                                                        padding: "20px",
                                                                                        border: "1px solid #e6edf5",
                                                                                        boxShadow: "0 3px 10px rgba(0,0,0,.04)"
                                                                                    }}
                                                                                >

                                                                                    <div
                                                                                        style={{
                                                                                            display: "flex",
                                                                                            justifyContent: "space-between",
                                                                                            alignItems: "center",
                                                                                            marginBottom: "20px",
                                                                                            flexWrap: "wrap",
                                                                                            gap: "10px"
                                                                                        }}
                                                                                    >

                                                                                        <div>

                                                                                            <h6
                                                                                                style={{
                                                                                                    margin: 0,
                                                                                                    fontWeight: 600,
                                                                                                    color: "#0f3d5e"
                                                                                                }}
                                                                                            >
                                                                                                Agregar estudios al convenio
                                                                                            </h6>

                                                                                            <span
                                                                                                style={{
                                                                                                    fontSize: "12px",
                                                                                                    color: "#6c757d"
                                                                                                }}
                                                                                            >
                                                                                                Selecciona cómo deseas agregar estudios al convenio
                                                                                            </span>

                                                                                        </div>

                                                                                        <div
                                                                                            style={{
                                                                                                display: "flex",
                                                                                                gap: "10px"
                                                                                            }}
                                                                                        >
                                                                                            <div
                                                                                                onClick={() => setTypeUpload("2")}
                                                                                                style={{
                                                                                                    padding: "10px 16px",
                                                                                                    borderRadius: "12px",
                                                                                                    cursor: "pointer",
                                                                                                    transition: ".2s",
                                                                                                    fontSize: "12px",
                                                                                                    fontWeight: 600,

                                                                                                    background:
                                                                                                        typeUpload === "2"
                                                                                                            ? "#0f3d5e"
                                                                                                            : "#eef3f7",

                                                                                                    color:
                                                                                                        typeUpload === "2"
                                                                                                            ? "#fff"
                                                                                                            : "#0f3d5e"
                                                                                                }}
                                                                                            >
                                                                                                <i className="pi pi-search mr-2" />
                                                                                                Búsqueda por examen
                                                                                            </div>

                                                                                            <div
                                                                                                onClick={() => setTypeUpload("1")}
                                                                                                style={{
                                                                                                    padding: "10px 16px",
                                                                                                    borderRadius: "12px",
                                                                                                    cursor: "pointer",
                                                                                                    transition: ".2s",
                                                                                                    fontSize: "12px",
                                                                                                    fontWeight: 600,

                                                                                                    background:
                                                                                                        typeUpload === "1"
                                                                                                            ? "#0f3d5e"
                                                                                                            : "#eef3f7",

                                                                                                    color:
                                                                                                        typeUpload === "1"
                                                                                                            ? "#fff"
                                                                                                            : "#0f3d5e"
                                                                                                }}
                                                                                            >
                                                                                                <i className="pi pi-upload mr-2" />
                                                                                                Carga masiva
                                                                                            </div>



                                                                                        </div>

                                                                                    </div>
                                                                                    {typeUpload === "1" && (
                                                                                        <div className="upload-zone-modern">
                                                                                            <FileUpload
                                                                                                ref={fileUploadRef}
                                                                                                name="file"
                                                                                                customUpload
                                                                                                accept=".csv,.xlsx,.xls"
                                                                                                maxFileSize={10000000}
                                                                                                chooseLabel="Seleccionar archivo"
                                                                                                uploadLabel="Procesar"
                                                                                                cancelLabel="Cancelar"
                                                                                                emptyTemplate={emptyTemplate}
                                                                                                className="modern-upload"
                                                                                                uploadHandler={ExamIndication}
                                                                                            />

                                                                                            <div style={{ textAlign: "center", marginTop: "15px" }}>
                                                                                                <Button
                                                                                                    color="primary"
                                                                                                    onClick={downloadTemplateCSV}
                                                                                                    style={{
                                                                                                        background: "#ff9800",
                                                                                                        border: "none",
                                                                                                        fontWeight: 600,
                                                                                                        padding: "10px 18px",
                                                                                                        borderRadius: "8px"
                                                                                                    }}
                                                                                                >
                                                                                                    Descargar plantilla
                                                                                                </Button>
                                                                                            </div>


                                                                                        </div>
                                                                                    )}

                                                                                    {
                                                                                        // ?  UPLOAD EXAM BY EXAM
                                                                                    }
                                                                                    {
                                                                                        typeUpload === "2" && (

                                                                                            <Row className='g-4'>

                                                                                                <Col md="6">

                                                                                                    <div
                                                                                                        style={{
                                                                                                            border: "1px solid #e6edf5",
                                                                                                            borderRadius: "18px",
                                                                                                            padding: "20px",
                                                                                                            background: "#ffffff",
                                                                                                            height: "100%"
                                                                                                        }}
                                                                                                    >
                                                                                                        <div
                                                                                                            style={{
                                                                                                                display: "flex",
                                                                                                                alignItems: "center",
                                                                                                                justifyContent: "space-between",
                                                                                                                marginBottom: "18px"
                                                                                                            }}
                                                                                                        >

                                                                                                            <div
                                                                                                                style={{
                                                                                                                    display: "flex",
                                                                                                                    alignItems: "center",
                                                                                                                    gap: "12px"
                                                                                                                }}
                                                                                                            >

                                                                                                                <div
                                                                                                                    style={{
                                                                                                                        width: "48px",
                                                                                                                        height: "48px",
                                                                                                                        borderRadius: "14px",
                                                                                                                        background: "#eef6fb",
                                                                                                                        display: "flex",
                                                                                                                        alignItems: "center",
                                                                                                                        justifyContent: "center"
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <i
                                                                                                                        className="pi pi-search"
                                                                                                                        style={{
                                                                                                                            color: "#0f3d5e",
                                                                                                                            fontSize: "1.1rem"
                                                                                                                        }}
                                                                                                                    />
                                                                                                                </div>

                                                                                                                <div>

                                                                                                                    <div
                                                                                                                        style={{
                                                                                                                            fontWeight: 700,
                                                                                                                            color: "#0f3d5e",
                                                                                                                            fontSize: "15px"
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        1. Buscar y agregar estudios
                                                                                                                    </div>


                                                                                                                </div>

                                                                                                            </div>

                                                                                                        </div>

                                                                                                        <SearchAsync
                                                                                                            name={'id_exam_profile'}
                                                                                                            method={handleSelectTest}
                                                                                                            loincState={examProfileState}
                                                                                                            url="Profiles/SearchProfileExam"
                                                                                                            maxLenght={3}
                                                                                                        />

                                                                                                    </div>

                                                                                                </Col>

                                                                                                <Col md="6">

                                                                                                    <div
                                                                                                        style={{
                                                                                                            border: "1px solid #cfe2ff",
                                                                                                            borderRadius: "18px",
                                                                                                            padding: "20px",
                                                                                                            background: "#f4f9ff",
                                                                                                            height: "100%"
                                                                                                        }}
                                                                                                    >

                                                                                                        <div
                                                                                                            style={{
                                                                                                                display: "flex",
                                                                                                                alignItems: "center",
                                                                                                                gap: "12px",
                                                                                                                marginBottom: "18px"
                                                                                                            }}
                                                                                                        >

                                                                                                            <div
                                                                                                                style={{
                                                                                                                    width: "48px",
                                                                                                                    height: "48px",
                                                                                                                    borderRadius: "14px",
                                                                                                                    background: "#d9ebff",
                                                                                                                    display: "flex",
                                                                                                                    alignItems: "center",
                                                                                                                    justifyContent: "center"
                                                                                                                }}
                                                                                                            >
                                                                                                                <i
                                                                                                                    className="pi pi-percentage"
                                                                                                                    style={{
                                                                                                                        color: "#0f3d5e",
                                                                                                                        fontSize: "1.2rem"
                                                                                                                    }}
                                                                                                                />
                                                                                                            </div>

                                                                                                            <div>

                                                                                                                <div
                                                                                                                    style={{
                                                                                                                        fontWeight: 700,
                                                                                                                        color: "#0f3d5e",
                                                                                                                        fontSize: "15px"
                                                                                                                    }}
                                                                                                                >
                                                                                                                    2. Aplicar descuento global
                                                                                                                </div>

                                                                                                                <div
                                                                                                                    style={{
                                                                                                                        fontSize: "11px",
                                                                                                                        color: "#6c757d"
                                                                                                                    }}
                                                                                                                >
                                                                                                                </div>

                                                                                                            </div>

                                                                                                        </div>

                                                                                                        <Row className='align-items-end'>
                                                                                                            <Col sm="6">
                                                                                                                <Input
                                                                                                                    className="form-control input-air-primary b-r-10"
                                                                                                                    type="number"
                                                                                                                    disabled={
                                                                                                                        agreement_mode === "2" ||
                                                                                                                        agreement_mode === 2 ||
                                                                                                                        agreement_mode === "3" ||
                                                                                                                        agreement_mode === 3 ||
                                                                                                                        hasChanges
                                                                                                                    }
                                                                                                                    value={globalPercentage}
                                                                                                                    onChange={(e) =>
                                                                                                                        setGlobalPercentage(e.target.value)
                                                                                                                    }
                                                                                                                />
                                                                                                            </Col>

                                                                                                            <Col sm="6">

                                                                                                                <Button
                                                                                                                    outline
                                                                                                                    color='primary'
                                                                                                                    className='w-100'
                                                                                                                    onClick={() =>
                                                                                                                        handleCalculateGlobalPercentage(
                                                                                                                            id_agreement,
                                                                                                                            globalPercentage
                                                                                                                        )
                                                                                                                    }
                                                                                                                    disabled={hasChanges}
                                                                                                                >
                                                                                                                    Aplicar
                                                                                                                </Button>

                                                                                                            </Col>

                                                                                                        </Row>

                                                                                                        <div
                                                                                                            style={{
                                                                                                                marginTop: "18px",
                                                                                                                background: "rgba(13,59,89,.06)",
                                                                                                                borderRadius: "12px",
                                                                                                                padding: "12px 14px",
                                                                                                                fontSize: "11px",
                                                                                                                color: "#52606d",
                                                                                                                lineHeight: "1.7"
                                                                                                            }}
                                                                                                        >

                                                                                                            <i
                                                                                                                className="pi pi-info-circle mr-2"
                                                                                                                style={hasChanges ? { color: "#c92a2a" } : { color: "#0f3d5e" }}
                                                                                                            />
                                                                                                            {
                                                                                                                <label className={hasChanges ? "txt-danger" : ""}>
                                                                                                                    “Para aplicar el descuento, primero debe guardar el listado de estudios del Paso 1.”                                                                                                                </label>
                                                                                                            }

                                                                                                        </div>

                                                                                                    </div>

                                                                                                </Col>



                                                                                            </Row>
                                                                                        )
                                                                                    }
                                                                                </div>
                                                                            </Col>
                                                                        </Row>
                                                                    }
                                                                </Col>

                                                                {(agreement_mode === "3" || agreement_mode === 3) && (
                                                                    <Col xs="12" sm="6" md="6" lg="6" xl="6" className="pt-5">
                                                                        <span className="text-sm text-primary badge badge-light-primary f-12">
                                                                            Seleccionar tarifario de referencia
                                                                        </span>
                                                                        <br /><br />
                                                                        <Select
                                                                            name="id_rate"
                                                                            isClearable={true}
                                                                            placeholder="Selecciona una opción"
                                                                            options={listAgreement}
                                                                            onChange={(e) => handleSelectValuesA(e, 'id_rate')}
                                                                            value={id_rate}
                                                                            menuPlacement="top"
                                                                            className='input-air-primary b-r-9 border-danger border-1'
                                                                            menuPortalTarget={document.body}
                                                                        />

                                                                    </Col>
                                                                )}

                                                                {agreement_mode !== "1" && agreement_mode !== 1 && agreement_mode !== 3 && agreement_mode !== "3" && (
                                                                    <Col sm="4" className="pt-5">
                                                                        <span className="text-sm text-primary badge badge-light-primary f-12">
                                                                            Descuento global:
                                                                        </span>
                                                                        <br /><br />
                                                                        <Input
                                                                            className="form-control form-control-sm input-air-primary b-r-9"
                                                                            type="number"
                                                                            name='agreement_discount_global'
                                                                            value={agreement_discount_global}
                                                                            onChange={handleInputChangeA}
                                                                        />
                                                                    </Col>
                                                                )}
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            }
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                            {
                                // ? TABLE AGREEMENT
                            }
                            {
                                agreement_mode !== 2 &&
                                agreement_mode !== "2" &&
                                agreement_mode !== 3 &&
                                agreement_mode !== "3" && (
                                    <>
                                        <Card
                                            className={id_agreement > 0 ? 'shadow border-0 overflow-hidden' : 'd-none'}
                                            style={{
                                                borderRadius: '18px'
                                            }}
                                        >

                                            <div
                                                style={{
                                                    background: '#274b7a',
                                                    padding: '20px 25px'
                                                }}
                                            >
                                                <Row className="align-items-center">
                                                    <Col sm="8">
                                                        <h5
                                                            className="mb-1 text-white"
                                                            style={{
                                                                fontWeight: 700
                                                            }}
                                                        >
                                                            Estudios de Convenio
                                                        </h5>

                                                        <small
                                                            style={{
                                                                color: 'rgba(255,255,255,.85)',
                                                                fontsSize: '14px'
                                                            }}
                                                        >
                                                            Gestión de exámenes y perfiles incluidos en el convenio.
                                                        </small>
                                                    </Col>

                                                    <Col sm="4">
                                                        <label
                                                            style={{
                                                                color: '#fff',
                                                                fontSize: '12px'
                                                            }}
                                                        >
                                                            Cuando modifiques un precio, actualiza el convenio.
                                                        </label>

                                                        <Input
                                                            placeholder="Buscar por descripción o código..."
                                                            className="form-control b-r-12"
                                                            onChange={handleSearch}
                                                            style={{
                                                                border: 'none',
                                                                height: '42px'
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>
                                            </div>

                                            <CardBody className="p-4 agreement-table-body">

                                                {loadingAgreementTest ? (
                                                    <div className="agreement-table-loading">
                                                        <div className="agreement-table-loading-content">
                                                            <i className="fa fa-spin fa-spinner"></i>
                                                            <span>Cargando información...</span>
                                                        </div>
                                                    </div>
                                                ) : isSearching && (results === null || results.length === 0) ? (

                                                    <div style={{ textAlign: "center" }}>
                                                        <img
                                                            src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                            style={{ width: "20%" }}
                                                            alt=""
                                                        />
                                                        <br />
                                                        <p className="f-18 mt-3">
                                                            No se encontró ningún Examen / Perfil.
                                                        </p>
                                                    </div>

                                                ) : (

                                                    <Row>
                                                        <Col sm="12">

                                                            {
                                                                list_agrement_test.length === 0 ? (

                                                                    <div className="text-center py-5">

                                                                        <img
                                                                            src={require("../../assets/images/loginHelenLabs/HelenLabs.png")}
                                                                            alt="Helen Labs"
                                                                            className={
                                                                                view_exams
                                                                                    ? 'animate__animated animate__pulse animate__infinite'
                                                                                    : ''
                                                                            }
                                                                            style={{
                                                                                width: '150px',
                                                                                opacity: 0.95
                                                                            }}
                                                                        />

                                                                        <div className="mt-4">

                                                                            <h4
                                                                                style={{
                                                                                    fontWeight: 700,
                                                                                    color: '#0d3b59'
                                                                                }}
                                                                            >
                                                                                {
                                                                                    view_exams
                                                                                        ? "Carga masiva en progreso"
                                                                                        : "Seleccione los estudios que conformarán el convenio"
                                                                                }
                                                                            </h4>

                                                                            {
                                                                                !view_exams && (
                                                                                    <>
                                                                                        <p
                                                                                            className="mb-2"
                                                                                            style={{
                                                                                                fontWeight: 600,
                                                                                                color: '#495057',
                                                                                                fontSize: '15px'
                                                                                            }}
                                                                                        >
                                                                                            Aún no hay estudios configurados.
                                                                                        </p>

                                                                                        <p
                                                                                            className="mb-0 mx-auto"
                                                                                            style={{
                                                                                                maxWidth: '650px',
                                                                                                color: '#8a94a6',
                                                                                                fontSize: '13px',
                                                                                                lineHeight: '24px'
                                                                                            }}
                                                                                        >
                                                                                            Utiliza la carga masiva CSV o busca manualmente en la sección superior
                                                                                            para agregar exámenes y perfiles al convenio.
                                                                                        </p>
                                                                                    </>
                                                                                )
                                                                            }

                                                                        </div>

                                                                    </div>

                                                                ) : (

                                                                    <div className='table-responsive'>
                                                                        <TableAgreement
                                                                            {...{
                                                                                handleChangeRange,
                                                                                handleChangePercentage,
                                                                                handleDeleteRange,
                                                                                handleAddRange,
                                                                                handleChangePrice,
                                                                                list_agrement_test,
                                                                                number_format,
                                                                                handleCant,
                                                                                check_sanitary,
                                                                                is_micro,
                                                                                goNextPage,
                                                                                goPreviousPage,
                                                                                totalPages,
                                                                                actualPage,
                                                                                goToPage,
                                                                                prevPage,
                                                                                nextPage,
                                                                                totalRecords,
                                                                                resultCount,
                                                                                modalCancellation,
                                                                                method,
                                                                                toggleModalCancellation,
                                                                                handleTest,
                                                                                id_agreement,
                                                                                handleDeleteTestCreate
                                                                            }}
                                                                        />
                                                                    </div>

                                                                )
                                                            }

                                                        </Col>
                                                    </Row>

                                                )}

                                            </CardBody>

                                        </Card>
                                        <br /><br /><br />
                                    </>
                                )
                            }
                        </Col>
                    </Row>
                </Container>
            </>

            {
                modalAlert && (
                    <AlertDataTable
                        titleAlert="Confirmar cambio"
                        visibleAlert={modalAlert}
                        onHideAlert={closeDeleteAlert}
                        sizeAlert="medium-dialog delete-method"
                        messageAlert={
                            <>
                                Al cambiar al modo <strong>Tarifario Madre</strong>, se eliminarán los exámenes y perfiles en el {" "}
                                <strong>
                                    {url_helen === cedimi ? "Precio Especial" : "Listado Actual"}
                                </strong>.
                                Esta acción no se puede deshacer. ¿Deseas continuar?
                            </>
                        }

                        alert1={true}
                        titleAlert1={
                            <>
                                Nuevo modo de convenio: <strong>Tarifario Madre </strong>
                            </>
                        }
                        buttonAcept
                        titleNotLoading="Si, Continuar"
                        titleDanger="Cancelar"
                        actionAcept={() => handleDeleteAndSave()}
                        loadingAlert={loadingListCurrent}
                        titleLoading="Cargando..."

                    />
                )
            }

            {
                modalAlertCurrentlist && (
                    <AlertDataTable
                        titleAlert="Limpiar modo de convenio"
                        visibleAlert={modalAlertCurrentlist}
                        onHideAlert={closeDeleteAlertCurrentlist}
                        sizeAlert="medium-dialog delete-method"
                        messageAlert={
                            <>
                                ¿Está seguro de que desea borrar todos los estudios del modo de convenio: {" "}
                                <strong>
                                    {url_helen === cedimi ? "Precio Especial" : "Listado Actual"}
                                </strong>.
                                Esta acción no se puede deshacer. ¿Deseas continuar?
                            </>
                        }

                        alert1={true}
                        titleAlert1={
                            <>
                                Limpiar modo de convenio: {" "}
                                <strong>
                                    {url_helen === cedimi ? "Precio Especial" : "Listado Actual"}
                                </strong>
                            </>
                        }
                        buttonAcept
                        titleNotLoading="Si, Continuar"
                        titleDanger="Cancelar"
                        actionAcept={handleCleanCurrentlist}
                    />
                )
            }




            <ModalCodeCsv
                {
                ...{

                    modalListEgress, toggleModalListEgress, listCode, handlemove, listRepit, priceTarifarion, profileT

                }
                }
            />
            {
                <ModalDeleteTest
                    {
                    ...{
                        modalCancellation, toggleModalCancellation, handleTest, modalTitle, informationExams, handleDeleteTest
                    }
                    }
                />

            }

            {
                showInvoiceAlert && (
                    <Dialog
                        header={"Limpiar modo de convenio " ?? "---"}
                        visible={modalAlertAgreement}
                        headerStyle={{
                            backgroundColor: "#bd2130",
                            color: 'white',
                            fontWeight: 'bold',
                        }}
                        pt={{
                            header: { style: { backgroundColor: "#bd2130", color: 'white' } },
                            headerIcon: { style: { color: 'white' } },
                        }}
                        onHide={isAction2 ? toggleAlert2 : isAction3 ? toggleAlert3 : toggleAlert}
                        className="medium-dialog-agreement"
                        footer={
                            <>
                                {
                                    isAction && <Button
                                        size="sm"
                                        color="secondary"
                                        type="button"
                                        onClick={() => handleCleanCurrentlist(id_agreement)}
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <i className="fa fa-spinner fa-spin mr-1"></i>
                                                {"Limpiando..." ?? "Procesando..."}
                                            </>
                                        ) : (
                                            "limpiar" ?? "---"
                                        )}
                                    </Button>
                                }
                                {
                                    (isAction2 || isAction3) && (
                                        <Button
                                            size="sm"
                                            color="secondary"
                                            type="button"
                                            onClick={() => {
                                                saveOrUpdateAgreement();
                                            }}
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <i className="fa fa-spinner fa-spin mr-1"></i>
                                                    {"Actualizando..."}
                                                </>
                                            ) : (
                                                "Actualizar"
                                            )}
                                        </Button>
                                    )
                                }
                            </>
                        }
                    >
                        <Col sm="12" className='pt-1 pl-0 pr-0'>
                            <Col sm="12" className='pl-0 pr-0 pt-2'>
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "15px",
                                    marginBottom: "15px"
                                }}>
                                    <div style={{
                                        backgroundColor: "#ffe6e6",
                                        borderRadius: "50%",
                                        width: "100px",
                                        height: "55px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}>
                                        <AlertTriangle
                                            size={28}
                                            color="#c92a2a"
                                            style={{ display: "block" }}
                                        />
                                    </div>
                                    <div>
                                        <p
                                            className="mb-0"
                                            style={{
                                                fontSize: "13px",
                                                color: "#0d3b59"
                                            }}
                                        >
                                            {showMessageModal ?? "---"}
                                        </p>
                                    </div>
                                </div>
                            </Col>
                        </Col>
                    </Dialog>
                )
            }
        </Fragment >
    )
}
